import type { SectionTabsProps } from './types';

export function SectionTabs({
    sections,
    activeSection,
    onSectionClick,
    tabsContainerRef,
}: SectionTabsProps) {
    return (
        <div className="bg-white border-b shadow-sm">
            <div
                className="overflow-x-auto scrollbar-hide"
                ref={tabsContainerRef}
            >
                <div className="flex gap-4 px-4 py-3 min-w-max border-b border-gray-200">
                    {sections.map((section) => {
                        const capitalizedSection = section.charAt(0).toUpperCase() + section.slice(1);
                        return (
                            <button
                                key={section}
                                data-section={section}
                                onClick={() => onSectionClick(section)}
                                className={`flex-shrink-0 px-4 py-2 font-medium text-sm transition-all whitespace-nowrap relative ${
                                    activeSection === section
                                        ? 'text-orange-600'
                                        : 'text-gray-600 hover:text-gray-900'
                                }`}
                            >
                                {capitalizedSection}
                                {activeSection === section && (
                                    <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-orange-600" />
                                )}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
